import { createSelector } from './selector-utils'
import { createId } from '../utils/id'

/**
 * @param {string} rootKey
 * @param {string} idPrefix
 * @returns {{
 *   actionAddList: (initial: any) => any
 *   actionCheck: (id: string) => any
 *   actionUncheck: (id: string) => any
 *   selectRaw: (caseData: any) => { [id: string]: any }
 *   select: (caseData: any) => ({ id: string } & any)[]
 *   selectLabels: (caseData: any) => string[]
 * }}
 */
export const createChecklistHelpers = (rootKey, idPrefix) => {
  const required = ['label', 'order']
  /**
   * @param {string[]} listOfStrings
   * @returns {any} Updates to apply to case
   */
  const actionAddList = listOfStrings => {
    const updates = {}
    listOfStrings.forEach((name, index) => {
      updates[`${rootKey}.${createId(idPrefix)}`] = {
        label: name,
        order: index,
        complete: false,
      }
    })
    return updates
  }

  /**
   * @param {string} id
   * @returns {any} Updates to apply to case
   */
  const actionCheck = id => ({
    [`${rootKey}.${id}.complete`]: true,
  })

  /**
   * @param {string} id
   * @returns {any} Updates to apply to case
   */
  const actionUncheck = id => ({
    [`${rootKey}.${id}.complete`]: false,
  })

  const empty = {}

  /**
   * @param {any} caseData
   * @returns {{
   *   [id: string]: {
   *     label: string
   *     order: number
   *     complete: boolean
   *   }
   * }}
   */
  const selectRaw = caseData => caseData[rootKey] || empty

  /**
   * @param {any} caseData
   * @returns {Checklist}
   */
  const select = createSelector(selectRaw, raw => {
    const toReturn = []
    for (const id in raw) {
      const data = raw[id]
      // only return if has every prop
      if (!required.every(prop => data.hasOwnProperty(prop))) {
        continue
      }
      toReturn.push({ id, ...raw[id] })
    }
    toReturn.sort((a, b) => a.order - b.order)
    return toReturn
  })

  const selectLabels = createSelector(select, arr =>
    arr.map(item => item.label)
  )

  return {
    actionAddList,
    actionCheck,
    actionUncheck,
    selectRaw,
    select,
    selectLabels,
  }
}
